import type { AnomalyRow, Severity } from '../../hooks/useAnomalies';

export interface AnomalyGroup {
  key: string; // storeId|platform|date
  storeId: number;
  storeName: string;
  platform: string;
  date: string;
  rows: AnomalyRow[];
  worstSeverity: Severity;
  detectedAt: string; // latest detectedAt among rows
}

const SEV_RANK: Record<Severity, number> = { critical: 0, warning: 1, info: 2 };

export function groupAnomalies(rows: readonly AnomalyRow[]): AnomalyGroup[] {
  const byKey = new Map<string, AnomalyGroup>();
  for (const r of rows) {
    const key = `${r.storeId}|${r.platform}|${r.date}`;
    const existing = byKey.get(key);
    if (existing) {
      existing.rows.push(r);
      if (SEV_RANK[r.severity] < SEV_RANK[existing.worstSeverity]) {
        existing.worstSeverity = r.severity;
      }
      if (r.detectedAt > existing.detectedAt) {
        existing.detectedAt = r.detectedAt;
      }
    } else {
      byKey.set(key, {
        key,
        storeId: r.storeId,
        storeName: r.storeName,
        platform: r.platform,
        date: r.date,
        rows: [r],
        worstSeverity: r.severity,
        detectedAt: r.detectedAt,
      });
    }
  }
  // Sort groups: worst severity first, then most recent detection
  return Array.from(byKey.values()).sort((a, b) => {
    const sevDiff = SEV_RANK[a.worstSeverity] - SEV_RANK[b.worstSeverity];
    if (sevDiff !== 0) return sevDiff;
    return b.detectedAt.localeCompare(a.detectedAt);
  });
}
